import React from 'react'
import { AppointmentTypesContext } from './AppointmentTypesProvider'

function useAppointmentTypesState() {
    return React.useContext(AppointmentTypesContext)
}

export default useAppointmentTypesState
